import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { AFLDesignSystem } from '../components/AFLDesignSystem';

export const AFLDesignSystemTest = ({ store, data }) => {
    return (
        <Provider store={store}>
            <AFLDesignSystem {...data} />
        </Provider>
    );
};

AFLDesignSystemTest.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
